import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/api/global.service';
import { OpeningService } from 'src/app/api/money/opening.service';
import { ComunicationNavtopBranchofficeService } from 'src/app/utils/comunication-navtop-branchoffice.service';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import { ToolsService } from 'src/app/utils/tools.service';
import AlertifyHelper from 'src/app/utils/utils';
import * as _ from 'underscore';

@Component({
  selector: 'app-opening-list',
  templateUrl: './opening-list.component.html',
  styleUrls: ['./opening-list.component.css']
})
export class OpeningListComponent {
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  // variables
  user:any = null;
  date_now:any = null;
  checkbox:any = null;
  moneybox:any = null;
  check_moneybox:boolean = false;

  is_open:boolean = false;
  amount_opening:any = null;

  branchboxes: any = [];
  boxselected:any = null;
  summary_paymethods: any = [];

  constructor(
    private routeActivated: ActivatedRoute,
    private el: ElementRef,
    private renderer: Renderer2,
    private openingService: OpeningService,
    private router: Router,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private navigationTrackerService: NavigationTrackerService,
    private ComunicationNavtopBranchofficeService: ComunicationNavtopBranchofficeService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    this.checkBoxSelected();
  }

  checkBoxSelected() {
    let val_params = '';
    this.openingService.getCheckBoxSlected(val_params).subscribe({
      next: (data: any) => {        
        this.date_now = data.date;
        this.user = data.user;
        this.branchboxes = data.branchboxes;
        if(!_.isNull(data.data)){
          this.checkbox = data.data;
          this.boxselected =this.checkbox.id;
          this.getBoxOpening();
        }else{
          this.boxselected = this.branchboxes[0].id; 
          this.hideloaderModal();
        }
      }
    });
  }


  getBoxOpening(){
    this.showloaderModal();    
    this.ComunicationNavtopBranchofficeService.reloadData('load data');  
    this.openingService.getBoxOpening(this.checkbox.id).subscribe({
      next: (data: any) => {
        this.hideloaderModal();
        if(data.data){
          this.check_moneybox = true; 
          this.moneybox = data.data;
          this.summary_paymethods = data.summary_paymethods;
        }
      }
    });
  }


  selectBoxselected(){
    let data:any = [];
    this.openingService.updateBoxSelected(this.boxselected, data).subscribe({
      next: (data: any) => {
        this.showloaderModal();     
        this.checkBoxSelected();
      }
    });
  }


  changeBoxselected(){
    this.openingService.updateBoxSelected(this.boxselected, this.checkbox).subscribe({
      next: (data: any) => {
        this.showloaderModal();
        this.checkbox.id = data.data.branchbox_id;
        this.is_open = false;
        this.check_moneybox = false;
        this.moneybox = null;        
        this.summary_paymethods = [];        
        this.checkBoxSelected();
      }
    });
  }

  setFocusAmountOpening(){
     setTimeout(() => {  
      this.renderer .selectRootElement(
        this.el.nativeElement.querySelector("#amount_opening")
      ).focus();
    }, 50);    
  }

  openBox(){
    if (_.isNull(this.amount_opening) || _.isEmpty(this.amount_opening)) {
      this.alertifyMsg.warning('El monto inicial de apertura no puede estar vacío.');
      this.renderer .selectRootElement(
              this.el.nativeElement.querySelector("#amount_opening")
            )
            .focus();
    }else{
      let data:any = {}
      data.branchbox_id = this.checkbox.id;
      data.branchoffice_id = this.checkbox.branchoffice_id;
      data.amount_opening = this.amount_opening;
      this.openingService.openBox(data).subscribe({
        next: (data: any) => {
          this.alertifyMsg.success("! Se ha aperturado la caja con éxito ¡");
          this.check_moneybox = true; 
          this.showloaderModal();
          this.getBoxOpening(); 
        }
      });

    }
  }

  closeBox(){
    let options = {
      title: '¿Estás segur@?',
      message: "Está por cerrar la caja, antes le recomendamos realizar su arqueo !! ",
      cancel: 'Cancelar',
      confirm: 'Sí, CERRAR CAJA'
    };
    this.alert.confirmInfo(options).then((result: any) => {
      if (result.isConfirmed) {
        this.openingService.closeBox(this.moneybox).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success("! Caja cerrada con éxito ¡");
            this.moneybox.balance=0;
            this.resetValuesOpening();
            this.showloaderModal();
            this.getBoxOpening();    
          }
        });
      }
    });
  }

  resetValuesOpening(){
    this.check_moneybox = false;
    this.is_open = false;
    this.amount_opening = null;
    this.summary_paymethods = []; 
  }

  showloaderModal() {
    (<HTMLInputElement>document.getElementById('loading_moneybox')).style.display =
      'block';
  }

  hideloaderModal() {
    (<HTMLInputElement>document.getElementById('loading_moneybox')).style.display =
      'none';
  }

}